<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-dialogue">
    <el-dialog
      title=""
      v-show="show"
      :visible.sync="show"
      :close-on-click-modal="true"
      :close-on-press-escape="false"
      :show-close="true"
      append-to-body
      custom-class="wy-dialogue-custom-class">

      <div class="dialog-icon"></div>
      <div class="dialog-title">{{title ? title : defaultTitle}}</div>
      <slot/>

      <span slot="footer" class="dialog-footer">
        <el-button class="div-ok-btn" type="primary" @click="show = false">OK</el-button>
      </span>
    </el-dialog>
  </div>
</template>


<script>
export default {
  name: 'wy-confirmation',

  props: ["defaultTitle"],
 
  data() {
    return {
      show: false,
      title: null
    }
  }
}
</script>

<style lang="scss">
.wy-dialogue-custom-class.el-dialog {
    width: 567px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 2px 6px #0000000A;
    border: 2px solid #214586;
    border-radius: 25px;

  .el-dialog__body {
    padding: 0px 20px 43px 20px;
  }
    
  .dialog-icon {
    background-image: url('../../assets/icons/icon_warning_wys.png') !important;
    background-size: 135px;
    background-repeat: no-repeat;
    background-position-y: 0px;
    background-position-x: 30px;
    height: 168px;
    width: 30%;
    text-align: center;
    padding: 0px 46px 0px 0px;
    font-weight: 600;
    display: inline-block;
  }

  .dialog-title {
    display: inline-block;
    font-weight: 500;
    font-size: 21px;
    color: var(--site-font-primary-color);
    width: 280px;
    word-break: keep-all;
    vertical-align: 63px;
  }

  .dialog-footer {
    text-align: right;
    margin-top: 10px;
    
    .div-ok-btn {
      color: #FFFFFF;
      font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
      font-size: 16px;
      font-weight: 400;
      width: 77px;
      display: flex;
      height: 39px;
      float: right;
      position: relative;
      bottom: 42px;
      right: 3px;
      border-radius: 5px;
      background: #0C2837;
      border-color: #0C2837 !important;
      align-items: center;
      justify-content: center;
    }
  }     
}
</style>